// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_e564833","widgetRow":"_d42e83d","widgetHeaderRow":"_ec8f95d"};